export const MARKS_BUCKETS = ['1', '2', '3', '4', '5-7', '8+'] as const;

export type MarksBucket = (typeof MARKS_BUCKETS)[number];

export const MARKS_BUCKET_LABELS: Record<MarksBucket, string> = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5-7': '5–7',
  '8+': '8+',
};

export const isMarksBucket = (value: string | null | undefined): value is MarksBucket =>
  MARKS_BUCKETS.includes(value as MarksBucket);

export const getMarksFilterRange = (
  bucket: MarksBucket,
): { min: number; max: number | null } => {
  switch (bucket) {
    case '1':
      return { min: 1, max: 1 };
    case '2':
      return { min: 2, max: 2 };
    case '3':
      return { min: 3, max: 3 };
    case '4':
      return { min: 4, max: 4 };
    case '5-7':
      return { min: 5, max: 7 };
    case '8+':
      return { min: 8, max: null };
  }
};

const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const matchesMarksBucket = (
  marks: unknown,
  selected: MarksBucket | null,
): boolean => {
  if (!selected) return true;
  const range = getMarksFilterRange(selected);
  const value = toFiniteNumber(marks);
  if (value === null) return false;
  if (value < range.min) return false;
  if (range.max !== null && value > range.max) return false;
  return true;
};

export const getMarksBucket = (marks: unknown): MarksBucket | null => {
  for (const bucket of MARKS_BUCKETS) {
    if (matchesMarksBucket(marks, bucket)) return bucket;
  }
  return null;
};
